import axiosInstance from '../config/axios';

/**
 * Get current user's coin balance
 */
export const getMyCoinBalanceApi = () =>
  axiosInstance.get('/my-coin-balance').then((res) => res.data);

/**
 * Get active coin plans
 */
export const getCoinPlansApi = () =>
  axiosInstance.get('/coin-plans').then((res) => res.data);

/**
 * Get a specific coin plan by ID
 * @param {string} id 
 */
export const getCoinPlanByIdApi = (id) =>
  axiosInstance.get(`/coin-plans/${id}`).then((res) => res.data);

/**
 * Get user's coin transaction history
 */
export const getMyCoinTransactionsApi = () =>
  axiosInstance.get('/my-coin-transactions').then((res) => res.data);

/**
 * Purchase a coin plan
 * @param {{ coin_plan_id: string, charge_id?: string, payment_method?: string }} data
 */
export const purchaseCoinPlanApi = (data) =>
  axiosInstance.post('/purchase-coin-plan', data).then((res) => res.data);

/**
 * Cancel a recurring coin plan subscription
 * @param {string} subscriptionId
 */
export const cancelCoinSubscriptionApi = (subscriptionId) =>
  axiosInstance.post(`/coin-subscriptions/cancel/${subscriptionId}`).then((res) => res.data);

/**
 * Convert wallet balance to coins
 * @param {{ amount: number, coins: number }} data
 */
export const convertWalletApi = (data) =>
  axiosInstance.post('/convert-wallet', data).then((res) => res.data);

